<div class="px-15">
    <!-- Real-time Summaries Section -->
    <section id="pharmacy-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15"> Pharmacy Overviews </div>
                </div>
                <div class="subtitle"> Current real-time operational metrics </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'card'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <!-- New Prescriptions Card -->
                <mat-card class="card summary-card gradient-primary" (click)="navigateToMedicineRequests()">
                    <div class="card-top g-just-flex space-between">
                        <div class="left g-just-flex gap-8">
                            <mat-icon>receipt_long</mat-icon>
                            <span>New Prescriptions</span>
                        </div>
                    </div>
                    <div class="card-middle py-20">
                        <div class="value">{{ (newPrescriptions$ | async) ?? 0 }}</div>
                        <div class="label">Incoming Requests</div>
                    </div>
                    <div class="card-bottom">
                        <span>View Requests</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </mat-card>

                <!-- Pending Dispenses Card -->
                <mat-card class="card summary-card gradient-info" (click)="navigateToMedicationDispense()">
                    <div class="card-top g-just-flex space-between">
                        <div class="left g-just-flex gap-8">
                            <mat-icon>pending_actions</mat-icon>
                            <span>Pending Dispenses</span>
                        </div>
                    </div>
                    <div class="card-middle py-20">
                        <div class="value">{{ (pendingDispenses$ | async) ?? 0 }}</div>
                        <div class="label">Awaiting Fulfillment</div>
                    </div>
                    <div class="card-bottom">
                        <span>Dispense Now</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </mat-card>

                <!-- Low Stock Alerts Card -->
                <mat-card class="card summary-card gradient-warning" (click)="navigateToMedicineStock()">
                    <div class="card-top g-just-flex space-between">
                        <div class="left g-just-flex gap-8">
                            <mat-icon>warning</mat-icon>
                            <span>Low Stock Alerts</span>
                        </div>
                    </div>
                    <div class="card-middle py-20">
                        <div class="value">{{ (lowStockItems$ | async) ?? 0 }}</div>
                        <div class="label">Items below threshold</div>
                    </div>
                    <div class="card-bottom">
                        <span>Manage Inventory</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </mat-card>
            </div>
        </div>
    </section>

    <!-- Quick Actions Section -->
    <section id="quick-actions" class="scrolld-parent mt-40">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15"> Quick Actions </div>
                </div>
            </div>
            <div class="controls g-just-flex gap-15" [scrolld]="'action-button'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="action-button" (click)="addMedicine()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>local_pharmacy</mat-icon>
                    </div>
                    <span>Add Medication</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToMedicineRequests()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>list_alt</mat-icon>
                    </div>
                    <span>All Prescriptions</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToMedicineStock()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>inventory_2</mat-icon>
                    </div>
                    <span>Stock Management</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>
    </section>

    <!-- Tables Section -->
    <section id="med-inventory-alerts" class="scrolld-parent mt-40">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="mb-15"> Pharmacy Inventory Alerts </div>
                </div>
            </div>
            <div class="controls g-just-flex gap-15" [scrolld]="'smallTableCard'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>
        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30" style="align-items: stretch;">

                <!-- Expired Drugs Table -->
                <mat-card class="smallTableCard">
                    <mat-card-header>
                        <mat-card-title>
                            <div class="me-15"> Expired Drugs </div>
                        </mat-card-title>
                    </mat-card-header>
                    @if (expiredMedications$ | async; as medications) {
                    @if (medications.entry?.length) {
                    <app-tabled-option [columnMetaData]="expiredTableConfig.columnMetaData"
                        (selectedRow)="processSelectedRow($event)" [isToBeSelected]="true"
                        [columns]="expiredTableConfig.columns" [rawTableData]="$any(medications)">
                    </app-tabled-option>
                    } @else {
                    <div class="p-20">
                        <app-empty-state emptyStateTitle="No Expired Drugs"
                            emptyStateMessage="Great! There are no expired medications in your inventory.">
                        </app-empty-state>
                    </div>
                    }
                    }
                </mat-card>

                <!-- Low Stock Table -->
                <mat-card class="smallTableCard">
                    <mat-card-header>
                        <mat-card-title>
                            <div class="me-15"> Low Stock Medicines </div>
                        </mat-card-title>
                    </mat-card-header>
                    @if (lowStockMedications$ | async; as medications) {
                    @if (medications.entry?.length) {
                    <app-tabled-option [columnMetaData]="lowStockTableConfig.columnMetaData"
                        (selectedRow)="processSelectedRow($event)" [isToBeSelected]="true"
                        [columns]="lowStockTableConfig.columns" [rawTableData]="$any(medications)">
                    </app-tabled-option>
                    } @else {
                    <div class="p-20">
                        <app-empty-state emptyStateTitle="Stock Levels Good"
                            emptyStateMessage="All medications are above their low stock thresholds.">
                        </app-empty-state>
                    </div>
                    }
                    }
                </mat-card>

            </div>
        </div>
    </section>

    <div class="mt-40 mb-30 g-just-flex flex-between">
    </div>
       <app-upcoming-activities></app-upcoming-activities>
</div>